import { useEffect, useState } from 'react';
import useViewer from '@hooks/useViewer';

// remove memberType check for 'NonMember' and 'Prospect' to match useIsMemberActive logic
// see that hook for more notes
const useIsViewerActiveMember = () => {
    const [isActiveMember, setIsActiveMember] = useState(null);
    const { viewer } = useViewer();

    useEffect(() => {
        if (!viewer) return;
        const { status } = viewer;
        setIsActiveMember(status === 'Active');
    }, [viewer]);

    return isActiveMember;
};

export default useIsViewerActiveMember;
